import { useRef, useEffect } from 'react';
import { REMOTE_OPENED, REMOTE_OPENED_ACK } from 'calling-integration-cross-tab/types/BroadcastEvents';
import { sendCrossTabMessage } from 'worker-connection-library/calling-cross-tab-utils/sendCrossTabMessage';
import { createBroadcastMessage } from 'calling-integration-cross-tab/messages/createBroadcastMessages';
import { useBroadcastEventHandler } from 'calling-integration-cross-tab/hooks/useBroadcastEventHandler';
import { UNINITIALIZED } from 'calling-internal-common/widget-status/constants/CallWidgetStates';
import { useThirdPartyWidgetDetailsContext } from 'calling-remote-common/context/ThirdPartyWidgetDetailsContext';
import { useDispatch } from 'calling-remote-common/hooks/useDispatch';
import { crossTabConnectionManager } from 'calling-integration-cross-tab/connectionManagement/CrossTabConnectionManager';
export const useOpenedRemoteExists = () => {
  const [context, dispatch] = useThirdPartyWidgetDetailsContext();
  const {
    replaceWidgetDetails
  } = useDispatch(dispatch);
  const hasSyncedWidgetDetailsRef = useRef(false);
  useEffect(() => {
    sendCrossTabMessage(createBroadcastMessage({
      type: REMOTE_OPENED,
      destinationConnectionId: crossTabConnectionManager.getLastUpdatedTab()
    }));
  }, []);
  useBroadcastEventHandler({
    onRemoteOpened: message => {
      if (context.thirdPartyCallStatus === UNINITIALIZED) {
        return;
      }
      sendCrossTabMessage(createBroadcastMessage({
        type: REMOTE_OPENED_ACK,
        payload: Object.assign({}, context),
        destinationConnectionId: message.originConnectionId
      }));
    },
    onRemoteOpenedAck: message => {
      // Receive ack message once
      if (!hasSyncedWidgetDetailsRef.current) {
        replaceWidgetDetails(message.payload);
        hasSyncedWidgetDetailsRef.current = true;
      }
    }
  });
};